module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active"
  }, [_c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [(_vm.mostrarModalAdjuntar) ? _c('div', {
    staticClass: "overlay-class"
  }, [_c('upload-image', {
    attrs: {
      "name": "adjuntar_documento_importante",
      "folder": "documentos_importantes"
    },
    on: {
      "save": _vm.guardarAdjunto,
      "close": _vm.closeModalAdjuntar
    }
  }, [_c('span', {
    attrs: {
      "slot": "explanation"
    },
    slot: "explanation"
  }, [_vm._v("Adjunta la imagen que sustenta tu permiso")])])], 1) : _vm._e()]), _c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        return _vm.closeModalAdd()
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.id) ? _c('span', [_vm._v("Editar documento importante")]) : _c('span', [_vm._v("Crear documento importante")])]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Orden")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orden),
      expression: "orden"
    }],
    staticClass: "input w-90",
    attrs: {
      "type": "number",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.orden)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orden = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10 text-center"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Activo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activo),
      expression: "activo"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.isLoading
    },
    domProps: {
      "checked": Array.isArray(_vm.activo) ? _vm._i(_vm.activo, null) > -1 : (_vm.activo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.activo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.activo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.activo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.activo = $$c
        }
      }
    }
  })])]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Descripcion")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descripcion),
      expression: "descripcion"
    }],
    staticClass: "input w-300",
    attrs: {
      "type": "text",
      "disabled": _vm.isLoading
    },
    domProps: {
      "value": (_vm.descripcion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descripcion = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "display-flex text-center jc-center"
  }, [
    [(_vm.ruta) ? _c('div', [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": _vm.ruta,
        "target": "_blank"
      }
    }, [_vm._m(0), _c('span', [_vm._v("Ver adjunto")])])]) : _c('div', [_c('button', {
      staticClass: "button is-small is-primary",
      on: {
        "click": _vm.openModalAdjuntar
      }
    }, [_vm._m(1), _c('span', [_vm._v("Adjuntar")])])])], (_vm.ruta) ? _c('span', {
      staticClass: "icon color-red margin-left-5 cursor-pointer",
      attrs: {
        "tittle": "Borrar adjunto"
      },
      on: {
        "click": function($event) {
          _vm.ruta = ''
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()
  ], 2)])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item is-success",
    on: {
      "click": _vm.guardar
    }
  }, [(_vm.isSaving) ? _c('span', [_vm._v("Guardando...")]) : _c('span', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('strong', [_vm._v("Cancelar")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paperclip is-small"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-upload is-small"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a443f63","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_gestion_documentos_importantes_editar.vue
// module id = 746
// module chunks = 0